import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import validators from 'utils/validators';
import generateFormValidation from 'utils/generateFormValidation';
import convertToFormErrors from 'utils/convertToFormErrors';
import { withRouter } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import SubmitButton from 'form/SubmitButton';
import { invalidateRequests } from 'redux-bees';

@withRouter

@reduxForm({
  form: 'ImportWpressSite',
  validate: generateFormValidation({
    wpressUrl: [validators.required()],
  }),
  onSubmit(values, dispatch, props) {
    return dispatch(api.importSite({
      data: {
        type: 'site',
        attributes: { ...values, isFtpImport: false },
      },
    }))
    .then(({ body: { data } }) => {
      props.history.push(`/site/${data.id}`);
      dispatch(invalidateRequests(api.getSites));
      dispatch(notice('ImportWpressSite.success'));
    })
    .catch((response) => {
      dispatch(alert('ImportWpressSite.error'));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class ImportWpressSite extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }

  render() {
    const { handleSubmit, submitting, error, dirty } = this.props;

    return (
      <Form error={error} onSubmit={handleSubmit}>
        <div className="formatted-content space--bottom-2">
          <p>
            Please follow these instructions:
          </p>
          <ol>
            <li>
              Install the&nbsp;
              <a href="https://wordpress.org/plugins/all-in-one-wp-migration/" target="_blank" rel="noopener noreferrer">All-in-One WP Migration® plugin</a>&nbsp;
              on your existing website;
            </li>
            <li>
              In your WordPress sidebar, select &quot;All-in-One WP
              Migration &gt; Export&quot;;
            </li>
            <li>
              Click on the &quot;Export to&quot; button and select the
              &quot;File&quot; option;
            </li>
            <li>
              Once the archive file is ready, right-click on the download
              button and copy its URL.
            </li>
          </ol>
          <img src="/assets/images/wpress-copy.png" alt="Screenshot" />
        </div>
        <Field label="ImportWpressSite.wpressUrl" name="wpressUrl" placeholder="http://www.example.com/wp-content/ai1wm-backups/yoursite.com-20170801-114918-748.wpress">
          <input type="text" className="form__input--large" />
        </Field>
        <SubmitButton
          dirty={dirty}
          className="button button--primary button--expand button--huge"
          submitting={submitting}
          label="ImportWpressSite.submit"
        />
      </Form>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/ImportWpressSite.jsx